<div class="-contact-head" *ngIf="title">
  <lucide-icon name="info" [size]="20"></lucide-icon>
  <h3>{{ title }}</h3>
</div>
@if (description) {
  <p [innerHTML]="description"></p>
}
@if (links.length > 0) {
<div class="-links">
  <app-link *ngFor="let item of links" [to]="item.path">{{ item.title }}</app-link>
</div>
}
